var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1561",
  "data-name": "Group 1561"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1559",
  "data-name": "Group 1559",
  transform: "translate(-303)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1562",
  "data-name": "Group 1562",
  transform: "translate(303)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_453",
  "data-name": "Rectangle 453",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1,
  opacity: 0.9
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 47,
  height: 47,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_430",
  "data-name": "Group 430",
  transform: "translate(12 14)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_25",
  "data-name": "Line 25",
  x1: 24,
  y2: 20,
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_27",
  "data-name": "Line 27",
  x1: 24,
  y1: 20,
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2
})))));
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Hamburger_Menu",
    "data-name": "Hamburger Menu",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6300a1b419a17db0569a835b43a11e17.svg";
export { ForwardRef as ReactComponent };